import { space, type SpaceToken } from "./tokens.ts";

export type SpacerProps = { size?: SpaceToken };

/** Fixed gap when `size` is set, otherwise takes the remaining space. */
export function Spacer({ size }: SpacerProps) {
  if (size === undefined) return <div className="b-spacer-flex" aria-hidden />;
  return <div aria-hidden style={{ flex: "none", width: space(size), height: space(size) }} />;
}
